<template>
  <div class="wrap">
    <slot name="content" />

    <div class="app-footer">
      <RouterLink
        v-if="showPolicyLink"
        class="app-footer__policy-link"
        to="/policy"
      >
        Политика конфиденциальности
      </RouterLink>
      <!-- <div class="app-version">
        {{ versionInfo.formatted }}
      </div> -->
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { getTelegramInitData } from "@/shared/lib/auth/telegramAuth";

const route = useRoute();

const showPolicyLink = computed(() => {
  const isHomeRoute = route.name === "home";
  const tg = (window as any).Telegram?.WebApp;

  if (!tg) {
    return isHomeRoute;
  }

  const { initData } = getTelegramInitData();
  const isTelegramApp = Boolean(initData && initData.length > 0);

  return !isTelegramApp && isHomeRoute;
});
</script>

<style lang="scss">
.wrap {
  background: $secondary-gradient;
  max-width: 100%;
  width: 100%;
  padding: 20px;
  height: var(--tg-viewport-height, var(--app-viewport-height, 100dvh));
  margin: 0 auto;
  color: $neutral-100;
  position: relative;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  // Учитываем безопасную область Telegram/OS, чтобы контент не уходил под нижнюю панель
  padding-bottom: calc(
    20px + var(--tg-safe-area-inset-bottom, 0px) +
      env(safe-area-inset-bottom, 0px)
  );
}

.app-footer {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding-bottom: 15px;
}

.app-footer__policy-link {
  @include p3-regular;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.75);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 2px;
}

.app-version {
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  pointer-events: none;
}
</style>
